var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalId,
            size: _vm.modalSize,
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
            "no-fade": "",
            "no-stacking": "",
            "hide-footer": "",
            centered: ""
          },
          on: {
            show: function($event) {
              ;(_vm.isModalOpen = true), _vm.getSubscriptionInformation()
            },
            hide: function($event) {
              _vm.isModalOpen = false
            }
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [
                  _c("div", [
                    _c(
                      "h2",
                      {
                        staticClass: "modal-title",
                        attrs: {
                          "data-test-hook": "new-subscription-modal-header"
                        }
                      },
                      [
                        _c("div", [
                          _c("i", {
                            staticClass: "far fa-badge-dollar colorOrange mr-1",
                            attrs: {
                              "data-test-hook":
                                "new-subscription-modal-header-icon"
                            }
                          }),
                          _vm._v(" " + _vm._s(_vm.modalTitle) + " ")
                        ])
                      ]
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm.isLoadingSubscriptionData
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "text-center" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("b-spinner", {
                            staticStyle: { width: "10rem", height: "10rem" },
                            attrs: { variant: "warning", label: "Spinning" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.activeView === _vm.subscriptionViews.NEW_HSB
                    ? _c("NewHsbSubscriptionView", {
                        attrs: {
                          "apparatus-details": _vm.apparatusDetails,
                          "apparatus-id": _vm.apparatusId,
                          "annual-paid-product": _vm.annualPaidProduct,
                          "monthly-paid-product": _vm.monthlyPaidProduct,
                          "account-data": _vm.accountProfile,
                          "selected-product": _vm.selectedProduct,
                          "is-creating-purchase-intent":
                            _vm.isCreatingPurchaseIntent
                        },
                        on: {
                          openPayment: _vm.proceedToPayment,
                          setSelectedProduct: _vm.setSelectedProduct
                        }
                      })
                    : _vm.activeView === _vm.subscriptionViews.EXISTING_LEGACY
                    ? _c("AddApparatusUpgradeFromLegacy", {
                        attrs: {
                          "account-data": _vm.accountProfile,
                          "selected-product": _vm.selectedProduct,
                          "apparatus-details": _vm.apparatusDetails,
                          "legacy-subscriptions": _vm.legacySubscriptions,
                          "apparatus-list": _vm.apparatusList,
                          "annual-paid-product": _vm.annualPaidProduct,
                          "monthly-paid-product": _vm.monthlyPaidProduct,
                          "is-creating-purchase-intent":
                            _vm.isCreatingPurchaseIntent
                        },
                        on: {
                          openPayment: _vm.proceedToPayment,
                          setSelectedProduct: _vm.setSelectedProduct
                        }
                      })
                    : _vm.activeView === _vm.subscriptionViews.NEW_TANK
                    ? _c("NewTankSubscriptionView", {
                        attrs: {
                          "selected-product": _vm.selectedProduct,
                          "annual-paid-product": _vm.annualPaidProduct,
                          "monthly-paid-product": _vm.monthlyPaidProduct,
                          "is-creating-purchase-intent":
                            _vm.isCreatingPurchaseIntent
                        },
                        on: {
                          setSelectedProduct: _vm.setSelectedProduct,
                          openPayment: _vm.proceedToPayment
                        }
                      })
                    : _vm.activeView === _vm.subscriptionViews.EXISTING_SUB
                    ? _c("ExistingSubscriptionView", {
                        attrs: {
                          "apparatus-id": _vm.apparatusId,
                          "account-profile": _vm.accountProfile,
                          "apparatus-details": _vm.apparatusDetails,
                          "existing-subscriptions": _vm.existingSubscriptions,
                          "apparatus-list": _vm.apparatusList,
                          "modal-id": _vm.modalId
                        }
                      })
                    : _vm.activeView ===
                      _vm.subscriptionViews.NEW_TANK_WITH_BASIC
                    ? _c("AddTankSubscriptionWithBasic", {
                        attrs: {
                          "selected-product": _vm.selectedProduct,
                          "apparatus-details": _vm.apparatusDetails,
                          "basic-hsb-list": _vm.basicHsbList,
                          "annual-paid-product": _vm.annualPaidProduct,
                          "monthly-paid-product": _vm.monthlyPaidProduct,
                          "is-creating-purchase-intent":
                            _vm.isCreatingPurchaseIntent
                        },
                        on: {
                          openPayment: _vm.proceedToPayment,
                          setSelectedProduct: _vm.setSelectedProduct
                        }
                      })
                    : _vm.activeView ===
                      _vm.subscriptionViews.UPGRADE_SINGLE_MULTI
                    ? _c("AddApparatusUpgradeSubscriptionEnrollment", {
                        attrs: {
                          isEnrollment: true,
                          "new-subscription": _vm.selectedProduct,
                          "current-subscription": _vm.existingSubscriptions[0],
                          "new-apparatuses": [_vm.apparatusDetails],
                          "apparatus-list": _vm.apparatusList,
                          "is-creating-purchase-intent":
                            _vm.isCreatingPurchaseIntent
                        },
                        on: { openPayment: _vm.proceedToPayment }
                      })
                    : _vm.activeView === _vm.subscriptionViews.ERROR
                    ? _c("SubscriptionInfoError", {
                        on: { retry: _vm.getSubscriptionInformation }
                      })
                    : _vm._e(),
                  _vm.activeView !== _vm.subscriptionViews.ERROR
                    ? _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c("b-col", { staticClass: "text-center" }, [
                            _c("p", { staticClass: "text-small legal-text" }, [
                              _vm._v(
                                "*" +
                                  _vm._s(
                                    _vm.$t(
                                      "xPushNotificationsAreAvailableWithInstallation"
                                    )
                                  )
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ]
      ),
      _c("PaymentModal", {
        attrs: {
          "modal-id": `${_vm.modalId}-payment`,
          "selected-product": _vm.selectedProduct,
          "account-profile": _vm.accountProfile
        },
        on: { submit: _vm.payForProduct, goBack: _vm.returnToSubscriptions }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }